import { render, staticRenderFns } from "./EmployeeleavePage.vue?vue&type=template&id=5174c242"
import script from "./EmployeeleavePage.vue?vue&type=script&lang=js"
export * from "./EmployeeleavePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports